import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from 'src/components/HTKit/Icon';
import styles from './styles.scss';

/*
 * Per discussion with Kareem in design, we are going to one-off this component for now under the assumption that
 * this component will be standardized and placed in the Design System at a future date. He showed me the designs
 * and communicated that a ticket will be forthcoming -GH Apr 26, 2022
 */
const AddSkuV2BannerMessaging = ({ sku, className }) => {
  const bannerText = sku && sku.getIn(['skuMessagings', 'banner']);
  if (!bannerText) return null;
  return (
    <aside className={cn(className, styles.componentContainer)}>
      <p className={styles.textContainer}>
        <Icon name="info-filled" className="marginRight-tiny1" />
        {`Note: ${bannerText}`}
      </p>
    </aside>
  );
};

AddSkuV2BannerMessaging.propTypes = {
  sku: PropTypes.object,
  className: PropTypes.string,
};

export default AddSkuV2BannerMessaging;
